import { LocationContext } from "@freightsimple/generated-dashboard-openapi-client/models/LocationContext";
import { describeLocationContext } from "@/Helpers/describeLocationContext";

/**
 * What the inside-service help bubble says.
 *
 * Two sentences, chosen by whether the location can have the service at all. A
 * residence can't (ENG-6496), and the bubble is the only place the customer can
 * find out why the checkbox they were looking for is greyed out — so it says
 * that instead of describing a service they can't buy.
 *
 * Its own file, and a plain string, so the wording can be asserted directly:
 * the bubble renders through a Tooltip, which only mounts its content on hover
 * and so leaves nothing in a snapshot.
 */
export function describeInsideAccessorial(
  locationContext: LocationContext,
  unavailableForResidential: boolean,
): string {
  if (unavailableForResidential) {
    // "Inside service" for the un-scoped case, which the address book uses:
    // describeLocationContext answers "Location" there, and "Inside location is
    // not available" is not a sentence.
    const noun =
      locationContext === LocationContext.Any
        ? "service"
        : describeLocationContext(locationContext).toLowerCase();

    return `Inside ${noun} is not available for residential locations.`;
  }

  const verb =
    locationContext === LocationContext.Pickup ? "pickup" : "deliver";

  return `The driver is required to go beyond the immediate area of the receiving door to ${verb} the freight.`;
}
